import { render } from "./DashboardSupervisor.vue?vue&type=template&id=f2a14be0"
import script from "./DashboardSupervisor.vue?vue&type=script&lang=js"
export * from "./DashboardSupervisor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__